import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=5466fd1e&scoped=true&"
import script from "./goodsInfo.vue?vue&type=script&lang=ts&"
export * from "./goodsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=5466fd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466fd1e",
  null
  
)

export default component.exports